var PlamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ObjectUtils } from "../../utils/object-utils";
import { ApplicationSearchService } from "../../../view-application/shared/application-search.service";
import { map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiPropertyAndLeaseConstants } from "../../constants/api-constants/api-property-and-lease.constants";
import { AlertType } from "../../models/alert";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { ApplicationSearchConstants } from "../../../view-application/shared/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../view-application/view-application-routing.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../../shared/utils/recipient-utils";
import { CreateApplicationDetailsPlamsComponent } from "../../../create-application/modules/pl/create-application-details-plams/create-application-details-plams.component";
import { CreateApplicationLocationPlamsComponent } from "../../../create-application/modules/pl/create-application-location-plams/create-application-location-plams.component";
import { SelectedApplicationService } from "../selected-application/selected-application.service";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { ApplicationCreateService } from "../../../create-application/shared/application-create.service";
import { ViewApplicationDetailsPlamsComponent } from "../../../view-application/modules/pl/view-application-details-plams/view-application-details-plams.component";
import { ViewApplicationLocationPlamsComponent } from "../../../view-application/modules/pl/view-application-location-plams/view-application-location-plams.component";
import { ApiWorkflowConstants } from "../../constants/api-constants/api-workflow.constants";
import { AutoUnsubPortal } from "../../decorators/autounsub-portal.decorator";
import { CreateApplicationLocationPlamsConstants } from "../../../create-application/modules/pl/create-application-location-plams/create-application-location-plams.constants";
import { ViewApplicationNotesComponent } from "../../../view-application/view-application-notes/view-application-notes.component";
import { CreateApplicationNotesComponent } from "../../../create-application/create-application-notes/create-application-notes.component";
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["LeaseStartDate"] = "Lease Start Date";
    ApplicationHeadingEnum["LeaseEndDate"] = "Lease End Date";
    ApplicationHeadingEnum["LeaseApplicationStatus"] = "Lease Application Status";
    ApplicationHeadingEnum["LeaseType"] = "Lease Type";
    ApplicationHeadingEnum["DateOfDeedTransfer"] = "Date of Deed Transfer";
    ApplicationHeadingEnum["SaleAmount"] = "Sale Amount";
    ApplicationHeadingEnum["EvaluationAmount"] = "Evaluation Amount";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ApplicationType, "applicationType"],
    [ApplicationHeadingEnum.LeaseStartDate, "leaseStartDate"],
    [ApplicationHeadingEnum.LeaseEndDate, "leaseEndDate"],
    [ApplicationHeadingEnum.LeaseApplicationStatus, "leaseApplicationStatus"],
    [ApplicationHeadingEnum.LeaseType, "leaseType"],
    [ApplicationHeadingEnum.DateOfDeedTransfer, "dateOfDeedTransfer"],
    [ApplicationHeadingEnum.SaleAmount, "saleAmount"],
    [ApplicationHeadingEnum.EvaluationAmount, "evaluationAmount"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["CreatedDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Phase";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ErfNumber, "erfNumbers"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "applicationType"],
    [ApplicationSummaryColumnsEnum.CreatedDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const PExpandListForApplicationPartial = ApplicationSearchConstants.APP_EXPAND_PORTAL_APP_PL;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Welcome"] = "Welcome";
    CreateApplicationMenuHeadings["Location"] = "Property";
    CreateApplicationMenuHeadings["Details"] = "Application";
    CreateApplicationMenuHeadings["Applicant"] = "Applicant";
    CreateApplicationMenuHeadings["Agent"] = "Agent";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
    CreateApplicationMenuHeadings["Documentation"] = "Required documentation";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var HeaderConfigurableTextTypes;
(function (HeaderConfigurableTextTypes) {
    HeaderConfigurableTextTypes["Welcome"] = "Welcome help";
    HeaderConfigurableTextTypes["Location"] = "Property help";
    HeaderConfigurableTextTypes["Details"] = "Application help";
    HeaderConfigurableTextTypes["Applicant"] = "Applicant help";
    HeaderConfigurableTextTypes["Agent"] = "Agent help";
    HeaderConfigurableTextTypes["Notes"] = "Notes help";
    HeaderConfigurableTextTypes["Documentation"] = "Required documentation help";
    HeaderConfigurableTextTypes["Communication"] = "Communication help";
    HeaderConfigurableTextTypes["Comments"] = "Comments help";
    HeaderConfigurableTextTypes["Summary"] = "Summary help";
})(HeaderConfigurableTextTypes || (HeaderConfigurableTextTypes = {}));
export var PageConfigurableTextTypes;
(function (PageConfigurableTextTypes) {
    PageConfigurableTextTypes["Welcome"] = "Welcome page";
})(PageConfigurableTextTypes || (PageConfigurableTextTypes = {}));
export const CreateAppHeadingConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, HeaderConfigurableTextTypes.Welcome)
    .set(CreateApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(CreateApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(CreateApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(CreateApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(CreateApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation);
export const CreateAppPageConfigurableTextType = new Map()
    .set(CreateApplicationMenuHeadings.Welcome, PageConfigurableTextTypes.Welcome);
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Status"] = "Application status";
    ViewApplicationMenuHeadings["Location"] = "Property";
    ViewApplicationMenuHeadings["Details"] = "Application";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant";
    ViewApplicationMenuHeadings["Agent"] = "Agent";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["Documentation"] = "Required documentation";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export const ViewAppHeadingConfigurableTextType = new Map()
    .set(ViewApplicationMenuHeadings.Status, HeaderConfigurableTextTypes.Summary)
    .set(ViewApplicationMenuHeadings.Location, HeaderConfigurableTextTypes.Location)
    .set(ViewApplicationMenuHeadings.Details, HeaderConfigurableTextTypes.Details)
    .set(ViewApplicationMenuHeadings.Applicant, HeaderConfigurableTextTypes.Applicant)
    .set(ViewApplicationMenuHeadings.Documentation, HeaderConfigurableTextTypes.Documentation)
    .set(ViewApplicationMenuHeadings.Notes, HeaderConfigurableTextTypes.Notes)
    .set(ViewApplicationMenuHeadings.Communication, HeaderConfigurableTextTypes.Communication)
    .set(ViewApplicationMenuHeadings.Comments, HeaderConfigurableTextTypes.Comments);
let PlamsStrategyService = class PlamsStrategyService extends AflaModuleStrategyService {
    static { PlamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    applicationCreateService;
    appControllerService;
    oDataQueryService;
    requestStatusService;
    selectedApplicationService;
    http;
    appController;
    router;
    createApplicationMenuHeadings;
    viewApplicationComponentLookup;
    name = ModuleConfig.PropertyAndLease;
    defaultSearchColumns;
    applicationEndpoint;
    createApplicationComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    applicationServiceUrl = ApiPropertyAndLeaseConstants.URL;
    form;
    userId;
    moduleUsers;
    expandListForApplicationPartial = PExpandListForApplicationPartial;
    lookups = new Map();
    createApplicationSteps = [];
    viewApplicationSteps = [];
    isFormValidSubject = new BehaviorSubject(false);
    isFormValidAsObservable = this.isFormValidSubject.asObservable();
    createAppHeadingConfigurableTextType = CreateAppHeadingConfigurableTextType;
    viewAppHeadingConfigurableTextType = ViewAppHeadingConfigurableTextType;
    createAppPageConfigurableTextType = CreateAppPageConfigurableTextType;
    previousApplication = null;
    savedApplication;
    postApplicationSubscription;
    getApplicationsSubscription;
    constructor(saShortDatePipe, applicationSearchService, applicationCreateService, appControllerService, oDataQueryService, requestStatusService, selectedApplicationService, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.applicationCreateService = applicationCreateService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.selectedApplicationService = selectedApplicationService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = `${ApiPropertyAndLeaseConstants.URL}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_MY_AFLA_PORTAL_PROPERTY_AND_LEASE_APPLICATIONS}`;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    static buildExpand(params) {
        return params.set(ODataAction.Expand, PExpandListForApplicationPartial);
    }
    buildListFilter(list, column) {
        const params = PlamsStrategyService_1.buildExpand(new HttpParams());
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: PlamsStrategyService_1.getRecipientName(PlamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: PlamsStrategyService_1.getRecipientName(PlamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            startDate: this.saShortDatePipe.transform(application.createdDate),
            // TODO: we have relabelled all instances of "Phase" to "Application status"
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null ? this.saShortDatePipe.transform(application.lastEditedDate) : "",
            moduleId: application.moduleId,
            applicationType: application.applicationType,
            leaseStartDate: application.leaseStartDate,
            leaseEndDate: application.leaseEndDate,
            leaseApplicationStatus: application.leaseApplicationStatus,
            leaseType: application.leaseType,
            dateOfDeedTransfer: application.dateOfDeedTransfer,
            saleAmount: application.saleAmount,
            evaluationAmount: application.evaluationAmount,
            erfNumbers: ObjectUtils.getCommaSeparatedValuesFromListForKey(application.properties, "erfNumber"),
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        return this.defaultSearchModel(application);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsPlamsComponent,
            ],
            [ViewApplicationMenuHeadings.Notes, ViewApplicationNotesComponent],
            [ViewApplicationMenuHeadings.Location, ViewApplicationLocationPlamsComponent]
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsPlamsComponent,
            ],
            [CreateApplicationMenuHeadings.Notes, CreateApplicationNotesComponent],
            [CreateApplicationMenuHeadings.Location, CreateApplicationLocationPlamsComponent],
        ]);
    }
    getApplicationsQuery(params) {
        return this.http.get(this.applicationEndpoint, { params });
    }
    getAllApplicationsQuery(params) {
        return this.http.get(`${ApiPropertyAndLeaseConstants.URL}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_MY_AFLA_PORTAL_PROPERTY_AND_LEASE_APPLICATIONS}`, { params });
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = PlamsStrategyService_1.buildExpand(new HttpParams());
        params = this.oDataQueryService.filter(params, PlamsStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    createApplication(existingApplication) {
        const application = this.buildApplication(existingApplication);
        this.postApplicationSubscription = this.postApplicationService(application)
            .subscribe({
            next: (savedApplication) => {
                this.appController.showMessage(PlamsStrategyService_1.successMessage(savedApplication.referenceNumber, ""), AlertType.Success);
                this.resetForm();
                this.router.navigate([
                    AppRoutingConstants.createRouteToView(this.appController.selectedModuleID + "", ViewApplicationRoutingConstants.VIEW_APPLICATION_ROUTE, savedApplication.jobId + "")
                ]).then();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage("create property and lease application", error, CRUDOperation.Add);
            }
        });
    }
    setApplicationNotes(stepIndex, existingApplication) {
        const noteId = this.form.get("notesForm").get("id").value ? this.form.get("notesForm").get("id").value : 0;
        const noteValue = this.form.get("notesForm").get("note").value;
        let note;
        if (noteValue !== null && noteValue !== "") {
            note = [{ id: noteId, note: noteValue }];
        }
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.notes = note;
            application.eLodgementStep = stepIndex;
        }
        else {
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                notes: note,
                eLodgementComplete: false,
                eLodgementStep: stepIndex
            };
        }
        return application;
    }
    saveApplicationStep(step, existingApplication, missingLookupsForZones, continueAfterSave = true) {
        let application;
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                application = this.buildLocationStep(step.stepIndex, existingApplication, missingLookupsForZones);
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                application = this.buildDetailsStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                application = this.buildApplicantStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                application = this.buildApplicantAgentStep(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                application = this.setApplicationNotes(step.stepIndex, existingApplication);
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                application = this.buildDocumentationStep(step.stepIndex, existingApplication);
                break;
            default:
                break;
        }
        if (application) {
            if (application.hasOwnProperty("applicationTypes")) {
                delete application.applicationTypes;
            }
            const applicationId = application.id > 0 ? application.id : 0;
            // application.canMoveToNextStepAfterSave = continueAfterSave;
            // the user must have chosen an application type before a partial save can be done
            if (applicationId === 0 && step.stepTitle === CreateApplicationMenuHeadings.Location && !application.applicationType) {
                this.appController.showMessage("An application type is required", AlertType.Warning);
                this.setIsFormValidSubject(false);
                this.form.get("propertiesForm").markAllAsTouched();
                this.requestStatusService.removeBusySpinner("continueToNextStep");
                return;
            }
            this.savedApplication = undefined;
            const applicationRequestDto = {
                plApplication: application,
                moveApplicationToNextStepAfterSave: continueAfterSave
            };
            this.createPartialApplicationObservable(applicationId, applicationRequestDto).subscribe({
                next: (savedApplication) => {
                    // had to do this because the saved application object does not return with the latest property owners
                    const params = {
                        $select: "properties,notes",
                        $expand: "properties($expand=owners($expand=groups)),leaseAreas,notes",
                        $filter: `jobId eq ${savedApplication.jobId} and moduleId eq ${+this.appControllerService.selectedModuleID}`
                    };
                    this.getApplicationsSubscription = this.getApplicationsQuery(params).subscribe({
                        next: (response) => {
                            const properties = response.value[0]?.properties;
                            const leaseAreas = response.value[0]?.leaseAreas;
                            savedApplication.properties = properties;
                            savedApplication.leaseAreas = leaseAreas;
                            this.savedApplication = savedApplication;
                        }, error: (error) => {
                            this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                        },
                        complete: () => {
                            if (this.savedApplication && continueAfterSave) {
                                this.selectedApplicationService.setIncompleteJobId(this.savedApplication.jobId);
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(`Application ${savedApplication.referenceNumber} ${step.stepTitle} saved successfully`, AlertType.Success, true);
                            }
                            else {
                                // NB: THIS WILL FIX ISSUE WITH THE SAVE BUTTON JUMPING TO THE NEXT STEP, NOT SO ELEGANT I KNOW... FILL FREE TO REMOVE IF IT YOU HAVE BETTER IDEA.
                                this.savedApplication.eLodgementStep = applicationRequestDto.plApplication.eLodgementStep;
                                this.selectedApplicationService.setSelectedApplication(this.savedApplication);
                                this.appController.showMessage(`Application ${savedApplication.referenceNumber} ${step.stepTitle} saved successfully`, AlertType.Success, true);
                            }
                            this.requestStatusService.removeBusySpinner("continueToNextStep");
                            this.requestStatusService.removeBusySpinner("TrueCentroid");
                        }
                    });
                }, error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Saving);
                    this.requestStatusService.removeBusySpinner("continueToNextStep");
                }
            });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Error);
            if (this.savedApplication && continueAfterSave) {
                this.setIsFormValidSubject(false);
            }
            this.requestStatusService.removeBusySpinner("continueToNextStep");
        }
    }
    saveResubmittedApplication(step, continueAfterSave, application) {
        return;
    }
    createPartialApplicationObservable(applicationId, applicationRequestDto) {
        return this.http.post(`${ApiPropertyAndLeaseConstants.URL}/${applicationId}/${ApiPropertyAndLeaseConstants.FUNCTION_CREATE_PARTIAL_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    creatResubmittedApplicationObservable(applicationId, applicationRequestDto, continueAfterSave) {
        return this.http.post(`${ApiPropertyAndLeaseConstants.URL}/${applicationId}/${ApiPropertyAndLeaseConstants.FUNCTION_CREATE_RESUBMITTED_APPLICATION}`, applicationRequestDto)
            .pipe(map((response) => {
            return response;
        }));
    }
    getCurrentFormName(step) {
        if (step === null)
            return "";
        let formName = "";
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                formName = "applicantForm";
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                formName = "applicantAgentForm";
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                formName = "detailsForm";
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                formName = "propertiesForm";
                break;
            case CreateApplicationMenuHeadings.Notes.toLocaleLowerCase():
                formName = "notesForm";
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                formName = "documentForm";
                break;
            default:
                break;
        }
        return formName;
    }
    resetFormForStep(step) {
        switch (step.stepTitle.toLocaleLowerCase()) {
            case CreateApplicationMenuHeadings.Applicant.toLocaleLowerCase():
                this.form.get("applicantForm").get("applicantRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Agent.toLocaleLowerCase():
                this.form.get("applicantAgentForm").get("applicantAgentRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Details.toLocaleLowerCase():
                this.form.get("detailsForm").get("description").reset();
                this.form.get("detailsForm").get("applicationType").reset();
                this.form.get("detailsForm").get("leaseType").reset();
                this.form.get("detailsForm").get("lesseeType").reset();
                this.form.get("detailsForm").get("leaseReason").reset();
                this.form.get("detailsForm").get("saleAmountAlienation").reset();
                this.form.get("detailsForm").get("dateOfDeedTransferAlienation").reset();
                this.form.get("detailsForm").get("evaluationAmountAlienation").reset();
                this.form.get("detailsForm").get("lesseeRecipient").reset();
                break;
            case CreateApplicationMenuHeadings.Location.toLocaleLowerCase():
                this.form.get("propertiesForm").get("properties").clear();
                this.applicationCreateService.$clearLayerGraphicsSubject.next(true);
                break;
            case CreateApplicationMenuHeadings.Documentation.toLocaleLowerCase():
                break;
            default:
                break;
        }
    }
    // TODO: Define and Correct these forms
    resetForm() {
        this.form.reset();
        this.form.get("propertiesForm").get("properties").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiPropertyAndLeaseConstants.URL, params);
    }
    withdrawApplication(params) {
        return this.http.post(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_WITHDRAW_APPLICATION, params);
    }
    getWorkflowClosedStates() {
        return this.http.get(ApiWorkflowConstants.URL + "/" + ApiWorkflowConstants.FUNCTION_GET_WORKFLOW_CLOSED_STATES);
    }
    // TODO: Correct these return values
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, applicationTypes, properties, lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_PL_APPLICATIONS_BY_USER;
        }
    }
    initialiseCreateApplicationSteps() {
        this.createApplicationSteps = [];
        for (const [key, value] of Object.entries(CreateApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === CreateApplicationMenuHeadings.Welcome ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.createApplicationSteps.push(step);
        }
    }
    initialiseViewApplicationSteps() {
        this.viewApplicationSteps = [];
        for (const [key, value] of Object.entries(ViewApplicationMenuHeadings)) {
            const step = {
                // this will be fixed - the others will be configurable
                stepId: `step_${key}`, // TODO: Can use something like this if required `${stepName} Sub-title`
                stepSubtitle: "",
                stepTitle: `${value}`,
                stepType: key === ViewApplicationMenuHeadings.Status ? "active" /* CalciteStepperItemType.active */ : "disabled" /* CalciteStepperItemType.disabled */, // TODO: Can use something like this if required `content`
                stepContent: ``,
            };
            this.viewApplicationSteps.push(step);
        }
    }
    getCreateApplicationStepsLookup(stepId) {
        const keys = [...this.createApplicationSteps.entries()]
            .filter(({ 1: v }) => v.stepId === stepId);
        if (keys.length > 0)
            return keys[0][1];
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiPropertyAndLeaseConstants.URL}/${jobId}/GetPlApplicationTypes`;
        return this.http.get(url, { params });
    }
    applicationHasGeometry() {
        if (this.form.get("propertiesForm") && this.form.get("propertiesForm").get("properties")) {
            const propertiesArray = this.form.get("propertiesForm").get("properties");
            if (propertiesArray.controls.length > 0) {
                return true;
            }
            else {
                this.appController.showMessage(CreateApplicationLocationPlamsConstants.PROPERTY_REQUIRED, AlertType.Warning);
                return false;
            }
        }
        else {
            this.appController.showMessage(CreateApplicationLocationPlamsConstants.PROPERTY_REQUIRED, AlertType.Warning);
            return false;
        }
    }
    queryConfigurableTextLookup(filter) {
        const params = {
            $filter: filter
        };
        return this.http.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params });
    }
    initForm() {
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
            }),
            applicantAgentForm: new FormGroup({
                applicantAgentRecipient: new FormControl(null, [Validators.required]),
                applicantAgentIsNull: new FormControl(null)
            }),
            documentForm: new FormGroup({
                documents: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                referenceNumber: new FormControl(null),
                description: new FormControl(null, [Validators.required]),
                applicationType: new FormControl(null, [Validators.required]),
                leaseType: new FormControl(null, [Validators.required]),
                leaseReason: new FormControl(null, [Validators.required]),
                lesseeType: new FormControl(null, [Validators.required]),
                lesseeRecipient: new FormControl(null, [Validators.required]),
                leaseUse: new FormControl(null, [Validators.required]),
                leaseRentalAgreementAmount: new FormControl(null, [Validators.required]),
                leaseStartDate: new FormControl(null, [Validators.required]),
                leaseEndDate: new FormControl(null, [Validators.required]),
                saleAmount: new FormControl(null, [Validators.required]),
                dateOfDeedTransfer: new FormControl(null, [Validators.required]),
                evaluationAmount: new FormControl(null, [Validators.required]),
                buyerRecipient: new FormControl(null, [Validators.required]),
                leaseContractNumber: new FormControl(null),
                leaseAccountNumber: new FormControl(null),
                leaseContractEscalation: new FormControl(null),
                leasePeriod: new FormControl(null),
                leaseNoticePeriod: new FormControl(null),
                sellerRecipient: new FormControl(null, [Validators.required]),
                saleAmountAlienation: new FormControl(null, [Validators.required]),
                dateOfDeedTransferAlienation: new FormControl(null, [Validators.required]),
                evaluationAmountAlienation: new FormControl(null, [Validators.required]),
                transferringAttorneyRecipient: new FormControl(null),
            }),
            notesForm: new FormGroup({
                id: new FormControl(0),
                note: new FormControl(null)
            }),
            propertiesForm: new FormGroup({
                applicationType: new FormControl(null, [Validators.required]),
                properties: new FormArray([]),
                leaseArea: new FormControl(null),
                leaseAreaId: new FormControl(null)
            })
        });
    }
    buildLocationStep(stepIndex, existingApplication, missingLookupsForZones) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.properties = [];
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                applicationType: "",
                moduleId: Number(this.appController.selectedModuleID),
                deleted: false,
                eLodgementStep: stepIndex,
                eLodgementComplete: false,
                properties: [],
                shape: "",
                wkid: 102100
            };
        // this should cover the copied applicant
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        if (applicantFormValue) {
            const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
            application.applicant = [applicant];
        }
        const points = [];
        application.applicationType = this.form.get("propertiesForm").get("applicationType").value?.value;
        const propertiesArray = this.form
            .get("propertiesForm")
            .get("properties");
        propertiesArray.controls.forEach((item) => {
            const centroid = item.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
            const geometry = item.get("geometry").value;
            const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
            let owners = item.get("owners").value ? item.get("owners").value : [];
            if (owners && owners.length > 0) {
                owners = owners.map((owner) => {
                    owner = RecipientUtils.removeInvalidRecipientProperties(owner);
                    return owner;
                });
            }
            const property = {
                id: item.get("id").value,
                address: item.get("address").value,
                allotment: item.get("allotment").value,
                erfNumber: item.get("erfNo").value,
                farmNumber: item.get("farmNo").value,
                zoning: item.get("zoning").value,
                streetNumber: item.get("streetNumber").value,
                streetName: item.get("streetName").value,
                town: item.get("town").value,
                isDummy: false,
                sgCode: item.get("sgCode").value,
                shape: geometryJSON,
                subdivision: item.get("subdivision").value,
                updateGeometry: false,
                wkid: 102100,
                owners
            };
            if (item.get("property") && item.get("property").value.id > 0) {
                property.id = +item.get("property").value.id;
                property.applicationId = application.appId;
                property.jobId = application.jobId;
            }
            application.properties.push(property);
        });
        application.shape = `MULTIPOINT (${points.join(", ")})`;
        // only save the lease area if the application has not been saved previously
        if (application.applicationType === "Lease") {
            const geomLease = this.form.get("propertiesForm").get("leaseArea").value;
            if (geomLease === null) {
                return null;
            }
            const leaseAreaGeometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geomLease);
            const leaseArea = {
                wkid: 102100,
                shape: leaseAreaGeometryJSON
            };
            if (existingApplication) {
                leaseArea.id = this.form.get("propertiesForm").get("leaseAreaId").value;
                leaseArea.applicationId = existingApplication.id;
            }
            application.leaseAreas = [leaseArea];
        }
        return application;
    }
    buildDetailsStep(stepIndex, existingApplication) {
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = false;
            application.description = this.form.get("detailsForm").get("description").value;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else {
            application = {
                id: 0,
                referenceNumber: "",
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: false,
                shape: ""
            };
        }
        application.applicationType = this.form.get("detailsForm").get("applicationType").value?.value;
        if (application.applicationType === "Lease") {
            application.leaseReason = this.form.get("detailsForm").get("leaseReason").value;
            application.leaseUse = this.form.get("detailsForm").get("leaseUse").value;
            application.leaseRentalAgreementAmount = this.form.get("detailsForm").get("leaseRentalAgreementAmount").value;
            application.leaseStartDate = this.form.get("detailsForm").get("leaseStartDate").value;
            application.leaseEndDate = this.form.get("detailsForm").get("leaseEndDate").value;
            application.leaseType = this.form.get("detailsForm").get("leaseType").value?.value;
            application.leaseLesseeType = this.form.get("detailsForm").get("lesseeType").value?.value;
            let lessees = this.form.get("detailsForm").get("lesseeRecipient").value;
            if (lessees && lessees.length > 0) {
                lessees = lessees.map((lessee) => {
                    lessee = RecipientUtils.removeInvalidRecipientProperties(lessee);
                    lessee.id = 0;
                    return lessee;
                });
            }
            else {
                lessees = [];
            }
            application.lessees = lessees;
        }
        if (application.applicationType === "Acquisition") {
            application.saleAmount = Number(this.form.get("detailsForm").get("saleAmount").value);
            application.dateOfDeedTransfer = this.form.get("detailsForm").get("dateOfDeedTransfer").value;
            application.evaluationAmount = Number(this.form.get("detailsForm").get("evaluationAmount").value);
            let sellers = this.form.get("detailsForm").get("sellerRecipient").value;
            if (sellers && sellers.length > 0) {
                sellers = sellers.map((seller) => {
                    seller = RecipientUtils.removeInvalidRecipientProperties(seller);
                    seller.id = 0;
                    return seller;
                });
            }
            else {
                sellers = [];
            }
            application.sellers = sellers;
        }
        if (application.applicationType === "Alienation") {
            application.saleAmount = Number(this.form.get("detailsForm").get("saleAmountAlienation").value);
            application.dateOfDeedTransfer = this.form.get("detailsForm").get("dateOfDeedTransferAlienation").value;
            application.evaluationAmount = Number(this.form.get("detailsForm").get("evaluationAmountAlienation").value);
            let buyers = this.form.get("detailsForm").get("buyerRecipient").value;
            if (buyers && buyers.length > 0) {
                buyers = buyers.map((buyer) => {
                    buyer = RecipientUtils.removeInvalidRecipientProperties(buyer);
                    buyer.id = 0;
                    return buyer;
                });
            }
            else {
                buyers = [];
            }
            application.buyers = buyers;
        }
        const properties = this.cleanPropertyOwners(application);
        if (properties.length > 0) {
            application.properties = properties;
        }
        return application;
    }
    cleanPropertyOwners(application) {
        const properties = [];
        if (application.hasOwnProperty("properties") && application.properties) {
            application.properties.forEach(prop => {
                if (prop.hasOwnProperty("owners") && prop.owners) {
                    const owners = [];
                    prop.owners.forEach(owner => {
                        owners.push(RecipientUtils.removeInvalidRecipientProperties(owner));
                    });
                }
                properties.push(prop);
            });
        }
        return properties;
    }
    buildApplication(existingApplication) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        return {
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            applicationType: this.form.get("detailsForm").get("applicationType").value.value,
            shape: "",
            wkid: 102100,
            applicant: applicant ? [applicant] : [],
            applicantAgent: [],
            notes: [],
            leaseAreas: [],
            properties: [],
            eLodgementComplete: false,
            eLodgementStep: 0
        };
    }
    buildApplicantStep(stepIndex, existingApplication) {
        this.form.get("applicantForm").get("applicantRecipient").enable();
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicant = applicant ? [applicant] : [];
            application.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicant: applicant ? [applicant] : [],
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                shape: ""
            };
        const properties = this.cleanPropertyOwners(application);
        if (properties.length > 0) {
            application.properties = properties;
        }
        return application;
    }
    buildApplicantAgentStep(stepIndex, existingApplication) {
        this.form.get("applicantAgentForm").get("applicantAgentRecipient").enable();
        const applicantAgentIsNullValue = this.form.get("applicantAgentForm").get("applicantAgentIsNull").value;
        const applicantFormValue = this.form.get("applicantAgentForm").get("applicantAgentRecipient").value;
        const applicantAgent = RecipientUtils.removeInvalidRecipientProperties(applicantFormValue);
        let application;
        if (existingApplication) {
            application = existingApplication;
            application.applicantAgent = applicantAgentIsNullValue ? [] : [applicantAgent];
            application.applicantAgentNa = applicantAgentIsNullValue;
            application.eLodgementStep = stepIndex;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                deleted: false,
                moduleId: Number(this.appController.selectedModuleID),
                applicantAgent: applicantAgent ? [applicantAgent] : [],
                eLodgementComplete: false,
                eLodgementStep: stepIndex,
                shape: ""
            };
        const properties = this.cleanPropertyOwners(application);
        if (properties.length > 0) {
            application.properties = properties;
        }
        if (applicantAgentIsNullValue) {
            this.form.get("applicantAgentForm").get("applicantAgentRecipient").disable();
        }
        return application;
    }
    buildDocumentationStep(stepIndex, existingApplication) {
        let application;
        const attachments = this.form.get("documentForm").get("documents").value;
        if (existingApplication) {
            application = existingApplication;
            application.attachments = attachments;
            application.eLodgementStep = stepIndex;
            application.eLodgementComplete = true;
            RecipientUtils.cleanPropertyOwners(application);
        }
        else
            application = {
                id: 0,
                attachments,
                moduleId: Number(this.appController.selectedModuleID),
                eLodgementStep: stepIndex,
                deleted: false,
                eLodgementComplete: true,
                shape: ""
            };
        const properties = this.cleanPropertyOwners(application);
        if (properties.length > 0) {
            application.properties = properties;
        }
        return application;
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return;
    }
    verifyExtensionReferenceNumberObservable(params) {
        return;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: ApplicationCreateService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: SelectedApplicationService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
PlamsStrategyService = PlamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsubPortal()
], PlamsStrategyService);
export { PlamsStrategyService };
